<template>
  <div class="c-coming-next">
    <div class="c-coming-next__next-product">
      <v-product-image
        v-if="!message"
        :product="product"
        class="c-coming-next__image"
        :type="ImageType.COVER"
      ></v-product-image>
      <div class="c-coming-next__wrapper">
        <button
          v-accessibility-focus="playAgain"
          class="o-button o-button--text o-button--text-white o-button--transparent u-uppercase c-coming-next__play-again"
        >
          <i class="o-icon o-icon--key-back o-button__icon"></i>
          <span class="o-button__label">
            {{ $t('player.comingNext.playAgain') }}
          </span>
        </button>
        <h2
          v-if="message"
          class="o-typography__headline2 c-coming-next__message"
        >
          {{ message }}
        </h2>
        <div
          v-else
          class="c-coming-next__content"
        >
          <p class="o-typography__title1 u-uppercase">
            {{ $t('player.comingNext.title') }}
          </p>
          <div class="c-coming-next__info">
            <h3 class="o-typography__headline3 c-coming-next__title">
              {{ product.title }}
            </h3>
            <p class="o-typography__subtitle3">
              {{ year }}
            </p>
            <p class="o-typography__subtitle3 c-coming-next__description u-desktop-only">
              {{ product.description }}
            </p>
          </div>
          <div class="o-separator o-separator--highlight"></div>
          <button
            v-accessibility-focus="playNext"
            class="o-button o-button--text o-button--text-white o-button--outline o-button--transparent u-uppercase c-coming-next__play"
          >
            <div
              ref="loader"
              class="c-coming-next__play-loader"
            ></div>
            <i class="o-icon o-icon--play o-button__icon c-coming-next__play-icon"></i>
            <span class="o-button__label c-coming-next__play-label">
              {{ $t('player.comingNext.play') }}
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { ImageType } from '@/shared/enums';
  import { meta } from '@/index/shared/filters';
  import VProductImage from '@/index/shared/components/product-image/index.vue';
  import { NavigationContextManager } from '@/shared/utils/accessibility';

  const DEFAULT_REDIRECTION_TIME_IN_SECONDS = 10;

  export default {
    name: 'ComingNext',
    components: {
      VProductImage,
    },
    props: {
      message: {
        type: String,
        default: '',
      },
      product: {
        type: Object,
        default: () => ({}),
      },
    },
    enums: {
      ImageType,
    },
    data() {
      const info = this.$services.resolve('info');
      const comingNextRedirectionTimeInSeconds = info.platformSettings.comingNextRedirectionTimeInSeconds || DEFAULT_REDIRECTION_TIME_IN_SECONDS;

      return {
        info,
        comingNextRedirectionTimeInSeconds,
        timeToRedirect: comingNextRedirectionTimeInSeconds,
      };
    },
    computed: {
      year() {
        return meta(this.product, 'year');
      },
    },
    watch: {
      timeToRedirect(newValue) {
        if (newValue > 0) {
          return;
        }

        clearInterval(this.redirectInterval);

        if (this.message || !this.product) {
          return this.goBack();
        }

        this.playNext();
      },
    },
    mounted() {
      NavigationContextManager.pushContext(this.$el, this.playAgain, { savePrevFocus: true, skipFocus: true });

      this.$refs.loader.style.transition = `transform ${this.comingNextRedirectionTimeInSeconds - 1}s linear`;

      this.redirectInterval = setInterval(() => {
        if (this.timeToRedirect === this.comingNextRedirectionTimeInSeconds) {
          this.$refs.loader.style.transform = 'translateX(0)';
        }

        this.timeToRedirect--;
      }, 1000);
    },
    beforeDestroy() {
      NavigationContextManager.popContext();

      clearInterval(this.redirectInterval);
    },
    methods: {
      goBack() {
        this.$router.goBack();
      },
      playAgain() {
        this.$emit('playAgain');
      },
      playNext() {
        this.$emit('playNext');
      },
    },
  };
</script>
